<template>
  <div class="row">
    <div
      class="col-md-2 text-center"
      :class="{
        'custom-change-red': latestChange > 0,
        'custom-change-green': latestChange < 0,
      }"
    >
      <span :title="lastTwo">{{ latestChange }}</span>
    </div>
    <div class="col-md-2 text-center">{{ starting }}</div>
    <div class="col-md-2 text-center">{{ latest }}</div>
    <div class="col-md-2 text-center">{{ target }}</div>
    <div class="col-md-4 text-center">
      <progress-gauge :progress="progress" :ceiling="ceiling" :width="120" />
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import globals from '@/Plugins/globals'
import ProgressGauge from './progress-gauge'
export default {
  name: 'bodyfat-progress',
  components: {
    ProgressGauge,
  },
  props: {
    row: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      ceiling: 100,
    }
  },
  mounted() {
    // console.log('Body Fat Progress', this.row)
  },
  computed: {
    progress() {
      let _progress = 0
      if (this.row !== undefined && this.row !== null) {
        if (
          this.row.measurements !== undefined &&
          this.row.measurements !== null
        ) {
          if (this.row.measurements.length > 1) {
            let _last = parseFloat(this.row.measurements[0].bodyFat)
            let _starting = 0
            let _target = 0
            if (this.row.targets !== undefined && this.row.targets !== null) {
              if (
                this.row.settargets !== undefined &&
                this.row.settargets !== null
              ) {
                _starting = `${globals.roundUp(
                  this.row.settargets.startFat,
                  1
                )}`
              } else {
                _starting = `${globals.roundUp(this.row.targets.startFat, 1)}`
              }
              _target = `${globals.roundUp(this.row.targets.targetFat, 1)}`
            }
            // was there a measurement?
            if (_last > 0) {
              let _change = _starting - _last
              let _diff = _starting - _target
              // Positive means they want to lose
              if (_diff > 0.1) {
                // If negative we've regressed..so zero percent progress
                if (_change > 0.1) {
                  _progress = (_change / _diff) * 100
                }
              } else if (_diff < -0.1) {
                // Negative number means they want to gain
                // If negative we've progressed...if positive zero percent progress
                if (_change < -0.1) {
                  // Make the number positive
                  _change = _change * -1
                  _diff = _diff * -1
                  _progress = (_change / _diff) * 100
                }
              } else {
                _progress = 100
              }
            }
          }
        }
      }
      this.ceiling = Math.round(_progress / 100) * 100
      return globals.roundUp(_progress, 1)
    },
    numDays() {
      let _data = null
      if (this.row !== undefined && this.row !== null) {
        if (
          this.row.measurements !== undefined &&
          this.row.measurements !== null
        ) {
          if (this.row.measurements.length > 1) {
            let _last = moment(this.row.measurements[0].createdOn)
            let _now = moment()
            _data = `${_now.diff(_last, 'days')} days ago`
          }
        }
      }
      return _data
    },
    lastTwo() {
      let _data = null
      if (this.row !== undefined && this.row !== null) {
        if (
          this.row.measurements !== undefined &&
          this.row.measurements !== null
        ) {
          if (this.row.measurements.length > 1) {
            let _prior = parseFloat(this.row.measurements[1].bodyFat)
            let _last = parseFloat(this.row.measurements[0].bodyFat)
            _data = `${_prior} -> ${_last}`
          }
        }
      }
      return _data
    },
    latestChange() {
      let _data = null
      if (this.row !== undefined && this.row !== null) {
        if (
          this.row.measurements !== undefined &&
          this.row.measurements !== null
        ) {
          if (this.row.measurements.length > 1) {
            let _prior = 0
            if (
              this.row.settargets !== undefined &&
              this.row.settargets !== null
            ) {
              _prior = parseFloat(this.row.settargets.startFat)
            } else if (
              this.row.targets !== undefined &&
              this.row.targets !== null
            ) {
              _prior = parseFloat(this.row.targets.startFat)
            }
            // let _prior = parseFloat(this.row.measurements[1].bodyFat)
            let _last = parseFloat(this.row.measurements[0].bodyFat)
            if (_prior !== 0 && _last !== 0) {
              _data = `${globals.roundUp(_last - _prior, 1)}`
            }
          }
        }
      }
      return _data
    },
    starting() {
      let _data = null
      if (this.row !== undefined && this.row !== null) {
        if (this.row.settargets !== undefined && this.row.settargets !== null) {
          _data = `${globals.roundUp(this.row.settargets.startFat, 1)}`
        } else if (
          this.row.targets !== undefined &&
          this.row.targets !== null
        ) {
          _data = `${globals.roundUp(this.row.targets.startFat, 1)}`
        }
      }
      return _data
    },
    latest() {
      let _data = null
      if (this.row !== undefined && this.row !== null) {
        if (
          this.row.measurements !== undefined &&
          this.row.measurements !== null
        ) {
          if (this.row.measurements.length > 1) {
            _data = `${globals.roundUp(this.row.measurements[0].bodyFat, 1)}`
          }
        }
      }
      return _data
    },
    target() {
      let _data = null
      if (this.row !== undefined && this.row !== null) {
        if (this.row.targets !== undefined && this.row.targets !== null) {
          _data = `${globals.roundUp(this.row.targets.targetFat, 1)}`
        }
      }
      return _data
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-change-red {
  color: red;
  font-weight: 500;
}
.custom-change-green {
  color: green;
  font-weight: 500;
}
</style>
